import { mdiVote } from "@mdi/js";
import Icon from "@mdi/react";
import { useContext } from "react";
import Loader from "../../../../common/loader/Loader";
import { ThemeContext } from "../../../../common/theme/ThemeContext";

const ElectionResultsDesktop = ({ results, typeName, generatedId }) => {
  const theme = useContext(ThemeContext);
  if (results) {
    const totalNumberOfVoters = results.voters;
    const receivedVotes = results.receivedVotes;
    return (
      <>
        <div className="is-flex is-align-items-center is-justify-content-center mt-6">
          <h1 className="m-0 mr-3 is-size-3">Elektronički</h1>
          <Icon path={mdiVote} size={2.2} className={`has-text-${theme.iconColor}`} />
          <h1 className="m-0 ml-3 is-size-3"> izbori</h1>
        </div>
        <div className="columns is-mobile mt-6">
          <div className="column is-three-fifths is-offset-one-fifth">
            <div className="is-size-3 has-text-centered">
              {typeName}
              <p className={`has-text-${theme.iconColor} is-size-3 has-text-centered`}>
                {generatedId === 3 ? " - glasovanje u tijeku" : " - glasovanje završeno"}
              </p>
            </div>
          </div>
        </div>
        <div className="columns is-mobile mt-6 is-centered">
          <div
            className="column is-10 is-centered is-flex"
            style={{ verticalAlign: "middle", display: "inline" }}
          >
            <span className="dot mt-1"></span>
            <div className="is-flex is-align-items-center">
              <p className="is-size-4 ml-5 " style={{ textAlign: "left" }}>
                Ukupno je glasovalo: {receivedVotes} članova od {totalNumberOfVoters} registriranih
              </p>
            </div>
          </div>
        </div>

        {results?.votes?.map((result, index) => {
          let percentage = (result.votes / receivedVotes) * 100;
          let percentageRounded = Math.round((percentage + Number.EPSILON) * 100) / 100;

          if (receivedVotes === 0) {
            percentageRounded = 0;
          }

          return (
            <div key={index} className="columns is-mobile mt-6 is-centered">
              <div
                className="column is-10 is-centered is-flex"
                style={{
                  boxShadow:
                    "rgba(14, 30, 37, 0.12) 0px 2px 4px 0px, rgba(14, 30, 37, 0.32) 0px 2px 16px 0px",
                  borderRadius: "5px",
                  borderBottom: `4px solid #7d658e `,
                }}
              >
                <div style={{ width: "100%", height: "75px" }}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      height: "100%",
                    }}
                  >
                    <div className="is-size-3 is-flex is-align-items-center">
                      {result.candidateNameSurname}
                    </div>
                    <div className={`is-flex is-align-items-center has-text-weight-bold `}>
                      <p className="m-0 is-size-3">{percentageRounded} %</p>
                      <p className="is-size-4 ml-6">
                        {result.votes} - {receivedVotes}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </>
    );
  } else {
    return <Loader />;
  }
};

export default ElectionResultsDesktop;
